<span class="title">{{title}}</span>
<mat-progress-bar mode="determinate" [value]="barValue" />
<span class="numbers">
  <strong>${{usage / 100 | terraNumber}}</strong>/${{limit / 100 | terraNumber}}
</span>
